import { ISurveyQuestion } from "../../../models/survey/survey-question.model";

export const hasSurveyAnswer = (answer: unknown): boolean => {
    if (Array.isArray(answer)) {
        return answer.some(hasSurveyAnswer);
    }

    if (typeof answer === "string") {
        return answer.trim().length > 0;
    }

    return answer !== null && answer !== undefined;
};

export const getAnsweredQuestionsByCategory = (
    questions: ISurveyQuestion[] | null = []
): Record<number, ISurveyQuestion[]> =>
    (questions || []).reduce<Record<number, ISurveyQuestion[]>>((grouped, question) => {
        if (!question.category || !hasSurveyAnswer(question.answers)) {
            return grouped;
        }

        const categoryId = question.category.categoryId;
        grouped[categoryId] = [...(grouped[categoryId] || []), question];

        return grouped;
    }, {});
